import React from 'react';

/**
 * @param children - Child components of the FadeTransitionWrapper.
 * @param {boolean} willShowElement - When true, fade in the child components. When false, fade out.
 */
interface FadeTransitionProps {
  children: JSX.Element
  willShowElement: boolean
}

/** A wrapping component that fades in (or fades out) child components. */
export const FadeTransitionWrapper = (props: FadeTransitionProps) => {
  const {children, willShowElement} = props;
    return (
        <div className={`pages-${willShowElement ? "visible" : "invisible"}`}>
          {children}
        </div>
    );
}